import React, { Component } from "react";
import PropTypes from "prop-types";
import { Fab, withStyles } from "@material-ui/core";
import classNames from "classnames";

import { ReactComponent as ImageIcon } from "../../assets/images/icons/mountains.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/icons/play.svg";
import { ReactComponent as ThreeDIcon } from "../../assets/images/icons/cube.svg";

import { controls as styles } from "./styles";

class Controls extends Component {
	render() {
		const handelIconButton = (icon, type) => {
			return (
				<Fab
					key={`js-btn-${type}`}
					className={classes.btn}
					color="primary"
					onClick={() => onClick(type)}
				>
					{icon}
				</Fab>
			);
		};
		const { classes, onClick, medias } = this.props;
		if (!medias) {
			return null;
		}
		return (
			<div className={classNames(classes.root)}>
				<p className={classes.title}>{"Immergez VOUS"}</p>
				<div className={classes.actions}>
					{Object.keys(medias).map(type => {
						const list = medias[type];
						if (list.length < 1) {
							return null;
						}
						if (type === "image") {
							return handelIconButton(
								<ImageIcon className={classes.btnIcon} />,
								type
							);
						}
						if (type === "video") {
							return handelIconButton(
								<VideoIcon className={classes.btnIcon} />,
								type
							);
						}
						if (type === "iframe") {
							return handelIconButton(
								<ThreeDIcon className={classes.btnIcon} />,
								type
							);
						}
					})}
				</div>
			</div>
		);
	}
}

Controls.propTypes = {
	classes: PropTypes.object.isRequired,
	medias: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(Controls);
